import BaseUseCase from "../../base_use_case.js.jsx";

import {
  TypesOfInvestmentExperience,
  CrowdfundingExperienceValue
} from "../../../questionnaire_constants.js";

class ShowInvestmentConfirmationInfoUseCase extends BaseUseCase {

  execute(params) {
    const { amount, participant: { projectId, user: { questionnaire: { data: questions = [] } } } } = params;

    const typesOfExperience = questions.find(item => item.key === TypesOfInvestmentExperience) || [];

    const queryParams = {
      amount: amount,
      projectId: projectId,
      hasCrowdfundingExperience: (typesOfExperience.multipleValueKeys || []).includes(CrowdfundingExperienceValue)
    };

    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/investments/confirmation_info`,
      params: queryParams
    }).then((result) => {
      return result
    })
  }
}

const instance = new ShowInvestmentConfirmationInfoUseCase();
export default instance;